import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {STRING_CONSTANTS} from "@config/constants/string.constants";
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'app-input-search',
  templateUrl: './input-search.component.html',
  styleUrls: ['./input-search.component.scss']
})
export class InputSearchComponent implements OnInit {

  @Input() isFinishLoadingSubject: BehaviorSubject<boolean>;
  @Input() placeholder: string
  @Input() value: string
  @Output() actionFilter = new EventEmitter<string>()


  STRING_CONSTANTS = STRING_CONSTANTS
  constructor() { }

  ngOnInit(): void {
  }

  handleSubmit = (event: string) => {
    // if(this.value){
      this.actionFilter.emit(event)
    // }
  }

  handleReset = () => {
    this.value = ''
    this.actionFilter.emit('')
  }

}
